
<template>
  <v-card-text>
        <v-card-text class="text-h6 font-weight-bold d-flex align-center">
            <v-icon size="40" class="mr-3">mdi-office-building</v-icon>
            {{ orga.name1 }} | {{ orga.bezeichnung}}
        </v-card-text>
        <v-card-text class="text-h6 font-weight-bold d-flex align-center">
            <v-icon size="40" class="mr-3">mdi-account-group</v-icon>
            {{ orga.bezeichnung}}
        </v-card-text>

        <v-card-text class="text-body-1 ">
            <v-icon size="28" class="mr-3">mdi-map-marker</v-icon>
            <span class=" text-h6 ">
                        {{ orga.strasse1 }}  {{ orga.plz }} {{ orga.ort }}, {{ orga.land }}
            </span>
    
        </v-card-text>

        <v-card-text v-if="orga.tel" class="text-body-1">
            <v-icon size="28" class="mr-3">mdi-phone</v-icon>
            <a :href="'tel:' + orga.tel" class="text-decoration-none text-primary text-h6">{{ orga.tel }}</a>
        </v-card-text>

        <v-card-text v-if="orga.email" class="text-body-1">
            <v-icon size="28" class="mr-3">mdi-email</v-icon>
            <a :href="'mailto:' + orga.email" class="text-decoration-none text-primary text-h6">{{ orga.email }}</a>
        </v-card-text>

    </v-card-text>
</template>



<script>
 /**
     * Displays organizational data in the dashboard.
     */
    export default {
        props: {
            orga: {
                type: Object,
                required: true
            }
        }
    };
</script>

<style scoped>
    a {
        color: inherit;
    }
    .v-card {
        display: flex;
        flex-direction: column;
        height: 100%;
    }

    .v-card-text {
        flex-grow: 1; /* This will ensure the content area grows to fill available space */
    }

</style>
